import { render, staticRenderFns } from "./IndividualSticker.vue?vue&type=template&id=6010da36&"
import script from "./IndividualSticker.vue?vue&type=script&lang=js&"
export * from "./IndividualSticker.vue?vue&type=script&lang=js&"
import style0 from "./IndividualSticker.vue?vue&type=style&index=0&id=6010da36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports